import { useEffect } from "react";
import { Link } from "react-router-dom";
import HomepageHeaderImg from "../images/homepage-header/Vallan-pest-control.png";
import RotatingTextAnimation from "./RotatingTextAnimation";
import AOS from "aos";
import 'aos/dist/aos.css';
import '../pages/home/home.css';

const HomePageHeader = () => {

    useEffect(() => {
        AOS.init({
            duration: 1000, // values from 0 to 3000, with step 50ms
            delay: 50, // values from 0 to 3000, with step 50ms
            easing: 'ease-in-out-cubic', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
        });
    }, []);

    return (
        <header className="homepage-header">
            <div className="homepage-header-texture-bg"></div>
            <div className="container home-page-container">
                <div data-aos="fade-up" className="homepage-header-left">
                    <h1 className="homepage-header-title">Welcome to PestEX Masters</h1>
                    <p className="homepage-header-text">We take out the Creeps!</p>
                    <span className="home-header-rotating-text"><RotatingTextAnimation /></span>
                    <p className="home-header-description">
                        At PestEX masters, we understand the importance of a pest-free environment for
                        your health and well-being. Our team uses the latest techniques and technologies to ensure that
                        your property is free from pests, while also taking into account the safety of your family, pets,
                        and the environment.
                    </p>
                    {/* <Link to="/contact" className="homepage-header-btn btn lg">Get A Quote</Link> */}
                </div>
                <div className="homepage-header-right">
                    <div className="home-page-header-image-cont">
                        <img src={HomepageHeaderImg} alt="Vallan pest control" />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default HomePageHeader